import { Component, LOCALE_ID, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SeminovosService } from '../seminovos-services/seminovos.service';
import { FiltroService } from '../../../../shared/filtro/filtro.service';
import { Filtros } from '../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';
import { Parametro } from '../../../../shared/service-base/parametro';

declare var $: any;

@Component({
  selector: 'app-seminovos-lista',
  templateUrl: './seminovos-lista.component.html',
  styleUrls: ['./seminovos-lista.component.css'],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'pt-BR'
    }
  ]
})
export class SeminovosListaComponent extends ListaBase implements OnInit {
  //totalNovosVendidos = 0;
  //totalUsadosVendidos = 0;
  //totalSelekt = 0;
  total_ano_novo_vendido = 0;
  total_ano_usado_vendido = 0;
  total_ano_volvo_selekt = 0;
  percent_total_ano_usado_novo_vendido = 0;
  percent_total_ano_selekt_usado_vendido = 0;
  total_ano_estoque_usado = 0;
  total_ano_estoque_volvo_usado = 0;
  percent_total_ano_volvo_estoque = 0;
  percent_total_ano_selekt_usado = 0;
  total_ano_margem_usado = 0;
  total_ano_margem_selekt = 0;
  percent_total_ano_margem_usado = 0;
  percent_total_ano_margem_selekt = 0;
  total_ano_custo_reparacao_selekt = 0;
  total_ano_tempo_prepara_selekt = 0;
  total_ano_tempo_estoque_seminovo = 0;
  total_ano_tempo_estoque_selekt = 0;
  periodo;
  display: boolean = false;
  meses: string[] = ['Jan'
    , 'Fev'
    , 'Mar'
    , 'Abr'
    , 'Mai'
    , 'Jun'
    , 'Jul'
    , 'Ago'
    , 'Set'
    , 'Out'
    , 'Nov'
    , 'Dez'
    , 'Total'
  ];

  consultaEstoque = {
    dadosSemiNovos: {
      periodo: [],
      categorias: [{ periodo: [] }]
    },
    estoqueVeiculo: {
      periodo: [],
      categorias: [{ periodo: [] }]
    }
  }

  percentualUsadosVendidos: [];
  percentualSelektUsadosVendidos: [];
  percentualUsadosEstoque: [];
  percentualQualificadosSelekt: [];
  dealers = [];
  gruposEconomicos = [];
  regioes = [];
  mercados = [];
  anoSelecao = [];

  carregando = true;

  constructor(
    service: SeminovosService,
    toastr: ToastrService,
    router: Router,
    private exportExcelService: ExportExcelService,
    private filter: FiltroService,
  ) {
    super(service, toastr, router,);
    this.nomeModulo = 'seminovos';
  }

  ngOnInit() {
    this.getAll();

    this.preencherMercados();
    this.preencherGruposEconomicos();
    this.preencherRegioes()
    this.preencherDealers();
    this.preencherAnoSelecao();
    this.cleanFilter();
  }

  getAll() {
    //this.preencherDealers();
    this.carregando = true;

    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    // this.preencherDealers();
    this.service.buscar(objFiltro)
      .then(res => {
        res.totalVendidos.forEach(element => {
          if (element.nome === 'Carros Volvo Selekt vendidos no mês (UNIDADES)') {
            element.nome = 'Carros Volvo Selekt vendidos Elegíveis no mês (UNIDADES)'
          }

          this.consultaEstoque.dadosSemiNovos.categorias = res.totalVendidos;
          this.consultaEstoque.estoqueVeiculo.categorias = res.veiculoEstoque;
          this.percentualUsadosVendidos = res.percentualUsadosVendidos;
          this.percentualSelektUsadosVendidos = res.percentualSelektUsadosVendidos;
          this.percentualUsadosEstoque = res.percentualUsadosEstoque;
          this.percentualQualificadosSelekt = res.percentualQualificadosSelekt;
        });
        this.calculandoTotal(res);
        this.carregando = false;
      });
    this.display = false
  }

  calculandoTotal(res) {

    this.total_ano_novo_vendido = res.totalVendidos[0].periodo[0].valor +
      res.totalVendidos[0].periodo[1].valor +
      res.totalVendidos[0].periodo[2].valor +
      res.totalVendidos[0].periodo[3].valor +
      res.totalVendidos[0].periodo[4].valor +
      res.totalVendidos[0].periodo[5].valor +
      res.totalVendidos[0].periodo[6].valor +
      res.totalVendidos[0].periodo[7].valor +
      res.totalVendidos[0].periodo[8].valor +
      res.totalVendidos[0].periodo[9].valor +
      res.totalVendidos[0].periodo[10].valor +
      res.totalVendidos[0].periodo[11].valor

    this.total_ano_usado_vendido = res.totalVendidos[1].periodo[0].valor +
      res.totalVendidos[1].periodo[1].valor +
      res.totalVendidos[1].periodo[2].valor +
      res.totalVendidos[1].periodo[3].valor +
      res.totalVendidos[1].periodo[4].valor +
      res.totalVendidos[1].periodo[5].valor +
      res.totalVendidos[1].periodo[6].valor +
      res.totalVendidos[1].periodo[7].valor +
      res.totalVendidos[1].periodo[8].valor +
      res.totalVendidos[1].periodo[9].valor +
      res.totalVendidos[1].periodo[10].valor +
      res.totalVendidos[1].periodo[11].valor

    this.total_ano_volvo_selekt = res.totalVendidos[2].periodo[0].valor +
      res.totalVendidos[2].periodo[1].valor +
      res.totalVendidos[2].periodo[2].valor +
      res.totalVendidos[2].periodo[3].valor +
      res.totalVendidos[2].periodo[4].valor +
      res.totalVendidos[2].periodo[5].valor +
      res.totalVendidos[2].periodo[6].valor +
      res.totalVendidos[2].periodo[7].valor +
      res.totalVendidos[2].periodo[8].valor +
      res.totalVendidos[2].periodo[9].valor +
      res.totalVendidos[2].periodo[10].valor +
      res.totalVendidos[2].periodo[11].valor

    this.total_ano_estoque_usado = res.totalVendidos[3].periodo[0].valor +
      res.totalVendidos[3].periodo[1].valor +
      res.totalVendidos[3].periodo[2].valor +
      res.totalVendidos[3].periodo[3].valor +
      res.totalVendidos[3].periodo[4].valor +
      res.totalVendidos[3].periodo[5].valor +
      res.totalVendidos[3].periodo[6].valor +
      res.totalVendidos[3].periodo[7].valor +
      res.totalVendidos[3].periodo[8].valor +
      res.totalVendidos[3].periodo[9].valor +
      res.totalVendidos[3].periodo[10].valor +
      res.totalVendidos[3].periodo[11].valor

    this.total_ano_estoque_volvo_usado = res.totalVendidos[4].periodo[0].valor +
      res.totalVendidos[4].periodo[1].valor +
      res.totalVendidos[4].periodo[2].valor +
      res.totalVendidos[4].periodo[3].valor +
      res.totalVendidos[4].periodo[4].valor +
      res.totalVendidos[4].periodo[5].valor +
      res.totalVendidos[4].periodo[6].valor +
      res.totalVendidos[4].periodo[7].valor +
      res.totalVendidos[4].periodo[8].valor +
      res.totalVendidos[4].periodo[9].valor +
      res.totalVendidos[4].periodo[10].valor +
      res.totalVendidos[4].periodo[11].valor

    this.total_ano_margem_usado = res.totalVendidos[5].periodo[0].valor +
      res.totalVendidos[5].periodo[1].valor +
      res.totalVendidos[5].periodo[2].valor +
      res.totalVendidos[5].periodo[3].valor +
      res.totalVendidos[5].periodo[4].valor +
      res.totalVendidos[5].periodo[5].valor +
      res.totalVendidos[5].periodo[6].valor +
      res.totalVendidos[5].periodo[7].valor +
      res.totalVendidos[5].periodo[8].valor +
      res.totalVendidos[5].periodo[9].valor +
      res.totalVendidos[5].periodo[10].valor +
      res.totalVendidos[5].periodo[11].valor

    this.total_ano_margem_selekt = res.totalVendidos[6].periodo[0].valor +
      res.totalVendidos[6].periodo[1].valor +
      res.totalVendidos[6].periodo[2].valor +
      res.totalVendidos[6].periodo[3].valor +
      res.totalVendidos[6].periodo[4].valor +
      res.totalVendidos[6].periodo[5].valor +
      res.totalVendidos[6].periodo[6].valor +
      res.totalVendidos[6].periodo[7].valor +
      res.totalVendidos[6].periodo[8].valor +
      res.totalVendidos[6].periodo[9].valor +
      res.totalVendidos[6].periodo[10].valor +
      res.totalVendidos[6].periodo[11].valor

    this.percent_total_ano_margem_usado = res.totalVendidos[7].periodo[0].valor +
      res.totalVendidos[7].periodo[1].valor +
      res.totalVendidos[7].periodo[2].valor +
      res.totalVendidos[7].periodo[3].valor +
      res.totalVendidos[7].periodo[4].valor +
      res.totalVendidos[7].periodo[5].valor +
      res.totalVendidos[7].periodo[6].valor +
      res.totalVendidos[7].periodo[7].valor +
      res.totalVendidos[7].periodo[8].valor +
      res.totalVendidos[7].periodo[9].valor +
      res.totalVendidos[7].periodo[10].valor +
      res.totalVendidos[7].periodo[11].valor

    this.percent_total_ano_margem_selekt = res.totalVendidos[8].periodo[0].valor +
      res.totalVendidos[8].periodo[1].valor +
      res.totalVendidos[8].periodo[2].valor +
      res.totalVendidos[8].periodo[3].valor +
      res.totalVendidos[8].periodo[4].valor +
      res.totalVendidos[8].periodo[5].valor +
      res.totalVendidos[8].periodo[6].valor +
      res.totalVendidos[8].periodo[7].valor +
      res.totalVendidos[8].periodo[8].valor +
      res.totalVendidos[8].periodo[9].valor +
      res.totalVendidos[8].periodo[10].valor +
      res.totalVendidos[8].periodo[11].valor

    this.total_ano_custo_reparacao_selekt = res.totalVendidos[9].periodo[0].valor +
      res.totalVendidos[9].periodo[1].valor +
      res.totalVendidos[9].periodo[2].valor +
      res.totalVendidos[9].periodo[3].valor +
      res.totalVendidos[9].periodo[4].valor +
      res.totalVendidos[9].periodo[5].valor +
      res.totalVendidos[9].periodo[6].valor +
      res.totalVendidos[9].periodo[7].valor +
      res.totalVendidos[9].periodo[8].valor +
      res.totalVendidos[9].periodo[9].valor +
      res.totalVendidos[9].periodo[10].valor +
      res.totalVendidos[9].periodo[11].valor

    this.total_ano_tempo_prepara_selekt = res.totalVendidos[10].periodo[0].valor +
      res.totalVendidos[10].periodo[1].valor +
      res.totalVendidos[10].periodo[2].valor +
      res.totalVendidos[10].periodo[3].valor +
      res.totalVendidos[10].periodo[4].valor +
      res.totalVendidos[10].periodo[5].valor +
      res.totalVendidos[10].periodo[6].valor +
      res.totalVendidos[10].periodo[7].valor +
      res.totalVendidos[10].periodo[8].valor +
      res.totalVendidos[10].periodo[9].valor +
      res.totalVendidos[10].periodo[10].valor +
      res.totalVendidos[10].periodo[11].valor

    this.total_ano_tempo_estoque_seminovo = res.totalVendidos[11].periodo[0].valor +
      res.totalVendidos[11].periodo[1].valor +
      res.totalVendidos[11].periodo[2].valor +
      res.totalVendidos[11].periodo[3].valor +
      res.totalVendidos[11].periodo[4].valor +
      res.totalVendidos[11].periodo[5].valor +
      res.totalVendidos[11].periodo[6].valor +
      res.totalVendidos[11].periodo[7].valor +
      res.totalVendidos[11].periodo[8].valor +
      res.totalVendidos[11].periodo[9].valor +
      res.totalVendidos[11].periodo[10].valor +
      res.totalVendidos[11].periodo[11].valor

    this.total_ano_tempo_estoque_selekt = res.totalVendidos[12].periodo[0].valor +
      res.totalVendidos[12].periodo[1].valor +
      res.totalVendidos[12].periodo[2].valor +
      res.totalVendidos[12].periodo[3].valor +
      res.totalVendidos[12].periodo[4].valor +
      res.totalVendidos[12].periodo[5].valor +
      res.totalVendidos[12].periodo[6].valor +
      res.totalVendidos[12].periodo[7].valor +
      res.totalVendidos[12].periodo[8].valor +
      res.totalVendidos[12].periodo[9].valor +
      res.totalVendidos[12].periodo[10].valor +
      res.totalVendidos[12].periodo[11].valor

  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.mercado
      || this.filtros.grupo_economico
      || this.filtros.regiao
      || this.filtros.dealer
      || this.filtros.anoSelecao
  }

  showDialog() {
    this.display = true;
  }

  carregar() {
    const objFiltro = new Filtros();

    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        objFiltro.filtros.push(new Parametro(chave, this.filtros[chave]));
      }
    }
  }

  exportExcel() {
    this.exportExcelService.nomeModulo = this.nomeModulo;
    this.exportExcelService.ExportTOExcel();
  }

  private preencherDealers() {
    if (this.filtros.grupo_economico !== undefined) {
      this.filter.buscar('dealerGrupo/'.concat(this.filtros.grupo_economico))
        .then(r => { this.dealers = r.filtros; });
    } else {
      this.filter.buscar('dealer')
        .then(r => { this.dealers = r.filtros; });
    }
  }

  preencherMercados() {
    this.filter.buscar('mercado')
      .then(r => { this.mercados = r.filtros; });
  }

  preencherGruposEconomicos() {
    this.filter.buscar('grupo_economico')
      .then(r => { this.gruposEconomicos = r.filtros; });
  }

  preencherRegioes() {
    this.filter.buscar('regiao')
      .then(r => { this.regioes = r.filtros; });
  }

  private preencherAnoSelecao() {
    const anoAtual = new Date().getFullYear();
    this.anoSelecao = [
      { descricao: String(anoAtual - 1), id: String(anoAtual - 1) },
      { descricao: String(anoAtual - 2), id: String(anoAtual - 2) },
      { descricao: String(anoAtual - 3), id: String(anoAtual - 3) },
      { descricao: String(anoAtual - 4), id: String(anoAtual - 4) },
    ];
  }

  cleanFilter() {
    this.filtros.dealers = undefined
    this.filtros.grupo_economico = undefined
    this.filtros.regiao = undefined
    this.filtros.mercado = undefined
    this.filtros.anoSelecao = undefined
  }
}